import React, { Component } from "react";
import FireBase from "firebase/app";
import _ from "lodash";
import ArrangeIcon from "material-ui/svg-icons/action/reorder";

import {
  TextField,
  IconButton,
  Toggle,
  Paper,
  RaisedButton,
  Checkbox,
} from "material-ui";
import LinearProgress from "../components/LinearProgress";
import FileUpload from "../components/FileUpload";
import firebase from "../firebase";
import uuid from "uuid/v1";
import withFirestorePath from "../components/withFirestorePath";
import RemoveProductIcon from "material-ui/svg-icons/content/clear";
import {
  arrayMove,
  SortableContainer,
  SortableElement,
} from "react-sortable-hoc";
import AddModifierDialog from "../components/AddModifierDialog";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  toggleStyle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  saveButton: {
    marginTop: 15,
    marginRight: 8,
  },
};

const SortableModifier = SortableElement(({ value, onRemove }) => (
  <Paper
    style={{
      paddingLeft: 8,
      backgroundColor: "tomato",
      color: "white",
      marginBottom: 8,
      alignContent: "center",
      display: "flex",
      cursor: "pointer",
    }}
  >
    <ArrangeIcon
      color="white"
      style={{ alignSelf: "center", marginRight: 4 }}
    />
    <h4 style={{ flex: 1 }}>{value.name}</h4>
    <IconButton onClick={onRemove}>
      <RemoveProductIcon color="white" />
    </IconButton>
  </Paper>
));

const SortableModifierList = SortableContainer(({ items, onRemoveItem }) => {
  return (
    <div>
      {items.map((value, index) => (
        <SortableModifier
          key={`item-${index}`}
          index={index}
          value={value}
          onRemove={() => onRemoveItem(index, value)}
        />
      ))}
    </div>
  );
});

class EditProduct extends Component {
  state = {
    name: "",
    price: "",
    description: "",
    active: true,
    photoUrl: "",
    uploadProgress: 0,
    submitting: false,
    loading: true,
    category: null,
    categories: null,
    uploading: false,
    productId: null,
    modifiers: null,
    createMode: false,
    restaurantId: null,
    addModifierDialogOpen: false,
    productId: null,
  };

  async fetchData() {
    const { params, restaurantPath } = this.props;
    const restaurantId = params.restaurantId;
    const productId = params.productId;
    const restaurantSnap = await restaurantPath.get();
    const restaurant = restaurantSnap.data();

    this.productPath = restaurantPath.collection("product");
    const categorySnaps = await restaurantPath.collection("category").get();
    let categories = [];
    if (categorySnaps.docs)
      categories = categorySnaps.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

    if (!productId) {
      this.setState({
        createMode: true,
        restaurantId,
        loading: false,
        native: !!restaurant.subscription,
        hasOnlineOrdering: !!restaurant.stripe_account,
        categories,
      });
      return;
    }

    try {
      const productSnap = await this.productPath.doc(productId).get();
      const modifierSnaps = await restaurantPath
        .collection("modifiers")
        .where(`products.${productId}`, ">=", 0)
        .orderBy(`products.${productId}`)
        .get();

      const product = productSnap.data();
      const modifiers = modifierSnaps.docs.map((modifier) => ({
        id: modifier.id,
        ...modifier.data(),
      }));

      this.setState({
        ...product,
        productId,
        restaurantId,
        modifiers,
        categories,
        native: !!restaurant.subscription,
        hasOnlineOrdering: !!restaurant.stripe_account,
        loading: false,
      });
    } catch (e) {
      console.log({ e });
      this.setState({
        loading: false,
      });
    }
  }

  async componentDidMount() {
    await this.fetchData();
  }

  handleSubmit = async (addAnother = false) => {
    this.setState({
      submitting: true,
    });

    const {
      createMode,
      name,
      price,
      description,
      active,
      photoUrl,
      category,
      productId,
      modifiers,
    } = this.state;
    const { restaurantPath } = this.props;

    const product = {
      name,
      price: price === "" ? 0 : price,
      description,
      active,
      category,
      photoUrl,
    };

    if (createMode) {
      product.createdAt = new Date();

      const createdProduct = await this.productPath.add(product);
      if (addAnother) {
        window.location.reload();
      } else {
        this.props.router.push(
          `/${restaurantPath.id}/edit-product/${createdProduct.id}`
        );
      }
    } else {
      product.updatedAt = new Date();
      await this.productPath.doc(productId).update(product);
      if (!modifiers) return;
      modifiers.forEach(async (modifier) => {
        await restaurantPath
          .collection("modifiers")
          .doc(modifier.id)
          .update(modifier);
      });

      await restaurantPath
        .collection("product")
        .doc(productId)
        .update({ modifiers: modifiers.map((m) => m.id) });
      if (addAnother) {
        this.props.router.push(`/${restaurantPath.id}/create-product`);
      } else {
        this.props.router.goBack();
      }
    }
  };

  handleImageDrop = (accepted, reject) => {
    const { restaurantId } = this.state;
    const file = accepted[0];
    const metadata = {
      contentType: file.type,
    };

    const uploadTask = firebase
      .storage()
      .ref(`/restaurants/${restaurantId}/products/${uuid()}${file.name}`)
      .put(file, metadata);

    uploadTask.on(
      FireBase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({
          uploadProgress: progress,
          uploading: true,
        });
      },
      (error) => {},
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          this.setState({
            photoUrl: downloadURL,
            uploading: false,
          });
        });
      }
    );
  };

  handleRemoveItem = (index, modifier) => {
    const { productId } = this.state;
    const newState = this.state.modifiers.map((m) => {
      if (modifier.id !== m.id) return m;

      m.products[productId] = null;
      return m;
    });

    this.setState({
      products: newState,
    });
  };

  renderCategories() {
    const { categories, restaurantId } = this.state;
    if (_.isEmpty(categories)) {
      return (
        <RaisedButton
          secondary
          label="Create Category"
          onClick={() =>
            this.props.router.push(`/${restaurantId}/create-category`)
          }
        />
      );
    }
    const productCategories = this.state.category;

    const onToggle = (id, active) => {
      const pos = active ? 1 : null;

      this.setState({
        category: {
          ...this.state.category,
          [id]: pos,
        },
      });
    };

    return categories.map(({ name, id }) => (
      <Checkbox
        key={id}
        label={name}
        checked={productCategories && productCategories[id]}
        onCheck={(e, active) => onToggle(id, active)}
      />
    ));
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const modifiers = [...this.state.modifiers];
    const { productId } = this.state;

    modifiers[oldIndex].products[productId] = newIndex;
    modifiers[newIndex].products[productId] = oldIndex;

    this.setState({
      products: arrayMove(modifiers, oldIndex, newIndex),
    });
  };

  handleModifiersSelected = (modifiers) => {
    const { productId } = this.state;
    const modifiersWithProduct = _.map(modifiers, (modifier, key) => ({
      ...modifier,
      products: { ...modifier.products, [productId]: 0 },
    }));
    this.setState({
      addModifierDialogOpen: false,
      modifiers: modifiersWithProduct.concat(this.state.modifiers),
    });
  };

  lazilyRenderAddModifierDialog() {
    const { addModifierDialogOpen } = this.state;
    if (!addModifierDialogOpen) return;

    return (
      <AddModifierDialog
        {...this.props}
        open={this.state.addModifierDialogOpen}
        skipModifiers={this.state.modifiers}
        autoScrollBodyContent={true}
        onModifiersSelected={this.handleModifiersSelected}
        onClose={() => this.setState({ addModifierDialogOpen: false })}
      />
    );
  }

  renderModifiersList() {
    const { createMode, productId, modifiers } = this.state;

    if (createMode)
      return <h4>Save this product in order to add modifiers to it</h4>;

    if (!modifiers) return;

    return (
      <div>
        <RaisedButton
          style={{ marginBottom: 15 }}
          onClick={() => this.setState({ addModifierDialogOpen: true })}
          label="Add Modifiers"
        />
        <SortableModifierList
          onRemoveItem={this.handleRemoveItem}
          items={modifiers.filter((m) => m.products[productId] !== null)}
          onSortEnd={this.onSortEnd}
        />
      </div>
    );
  }

  onPriceChanged = (e) => {
    let price = parseInt((parseFloat(e.target.value) * 100).toFixed(0));
    this.setState({ price });
  };

  render() {
    const {
      name,
      price,
      description,
      active,
      uploading,
      createMode,
      loading,
      submitting,
      photoUrl,
    } = this.state;

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h1>{createMode ? "Create Product" : "Edit Product"}</h1>
        <form style={styles.form}>
          <Paper style={styles.paper}>
            <TextField
              hintText="Name"
              value={name}
              onChange={(e) => this.setState({ name: e.target.value })}
              fullWidth
              floatingLabelText="Product Name"
            />
            <TextField
              hintText="Description"
              value={description}
              onChange={(e) => this.setState({ description: e.target.value })}
              fullWidth
              floatingLabelText="Description"
            />
            <TextField
              hintText="Base Price"
              value={price / 100}
              onChange={this.onPriceChanged}
              fullWidth
              type="number"
              step="0.01"
              floatingLabelText="Price"
            />

            <Toggle
              label="Available"
              labelPosition="right"
              toggled={active}
              onToggle={(e, active) => this.setState({ active })}
              style={styles.toggleStyle}
            />
          </Paper>
          {this.getModifiersSection()}
          <h2>Product Image</h2>
          <Paper style={{ padding: 15, display: "flex" }}>
            <FileUpload
              multiple={false}
              onDrop={this.handleImageDrop}
              accept="image/png, image/jpeg"
              uploadProgress={this.state.uploadProgress}
              uploading={this.state.uploading}
            />
            <img src={photoUrl} style={{ height: 200, marginLeft: 20 }} />
          </Paper>
          <RaisedButton
            label="Cancel"
            style={{ marginRight: 8 }}
            onTouchTap={() => this.props.router.goBack()}
          />
          <RaisedButton
            label="Save"
            style={styles.saveButton}
            onTouchTap={() => this.handleSubmit(false)}
            disabled={uploading || submitting}
            secondary
          />
          <RaisedButton
            label="Save and add another"
            style={styles.saveButton}
            onTouchTap={() => this.handleSubmit(true)}
            disabled={submitting || uploading}
            secondary
          />
        </form>
        {this.lazilyRenderAddModifierDialog()}
      </div>
    );
  }

  getModifiersSection() {
    const { hasOnlineOrdering } = this.state;
    if (!hasOnlineOrdering) return <div />;
    return (
      <div>
        <h2>Product Modifiers</h2>
        <Paper style={{ padding: 15 }}>{this.renderModifiersList()}</Paper>
      </div>
    );
  }
}

export default withFirestorePath(EditProduct);



// WEBPACK FOOTER //
// ./src/pages/EditProduct.js